import { LexicalNode } from 'lexical';
import { $isCustomListItemNode, CustomListItemNode } from '../nodes/CustomListItemNode';
import { $isCustomListNode, CustomListNode } from '../nodes/CustomListNode';

type FlatListItem = {
  item: CustomListItemNode;
  children: LexicalNode[];
  depth: number;
};

export function createFlatList(
  list: CustomListNode,
  depth = 0,
): FlatListItem[] {
  const items: FlatListItem[] = [];

  list.getChildren().forEach((item) => {
    if (!$isCustomListItemNode(item)) {
      throw new Error(`Wrong list child: ${item.getType()}`);
    }

    const children: LexicalNode[] = [];
    const catchItem = (): void => {
      if (!children.length) {
        return;
      }
      items.push({ item, children, depth });
    };

    item.getChildren().forEach((child) => {
      if ($isCustomListNode(child)) {
        catchItem();
        items.push(...createFlatList(child, depth + 1));

        return;
      }
      children.push(child);
    });
    catchItem();
  });

  return items;
}
